/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Tanvir Singh",
  title: "Hi all, I'm Tanvir",
  subTitle: emoji(
    "A passionate Fullstack Engineer having experience in building Applications with ReactJS, Angular, NodeJS, SpringBoot and a lot more."
  ),
  resumeLink:
    // "https://drive.google.com/file/d/1icT8PfWFH0macHK8gUoeoPfGqt02qVr0/view?usp=sharing", // Set to empty to hide the button
    "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/tanvirsingh007",
  linkedin: "https://www.linkedin.com/in/tanvir-singh-b21032236/",
  gmail: "singhtanvir032@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK DEV WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop Full Stack Web applications with industry standard tools."
    ),
    emoji("⚡ Develop Backend API services."),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Azure"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Guru Nanak Dev Engineering College",
      logo: require("./assets/images/gndec.png"),
      subHeader: "Btech in Electronics and Communication Engineering",
      duration: "2020 - 2024"
      // desc: "Participated in the research of XXX and published 3 papers.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Guru Nanak Public School",
      logo: require("./assets/images/school.png"),
      subHeader: "Class 11th & 12th - Science Major (Physics, Chemistry, Maths)",
      duration: "2018 - 2020"
      // desc: "Participated in the research of XXX and published 3 papers.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Fullstack Engineer",
      company: "Auribises Technologies",
      companylogo: require("./assets/images/auri.png"),
      date: "January 2023 – June 2024",
      // desc: "Part Time",
      // descBullets: [
      //   "Successfully transitioned manual deployment procedures to streamlined automated processes using Jenkins, Docker, and CI/CD methodologies.",
      //   "Developed robust and efficient REST APIs in Go, ensuring high performance and scalability.",
      //   "Dockerized Go applications to ensure consistency across different environments and simplify deployment, resulting in improved portability and resource utilization.",
      //   "Managed Linux servers for deployment purposes, ensuring stability, security, and optimal performance.",
      //   "Integrated WhatsApp API with our Angular applications, providing a comprehensive messaging solution for over 1,000 users."

      // ]
    },
    {
      role: "Software Engineer II",
      company: "Trilogy",
      companylogo: require("./assets/images/trilogy.png"),
      date: "June 2024 – Present",
      // desc: "Part Time",
      // descBullets: [
      //   "Successfully transitioned manual deployment procedures to streamlined automated processes using Jenkins, Docker, and CI/CD methodologies.",
      //   "Developed robust and efficient REST APIs in Go, ensuring high performance and scalability.",
      //   "Dockerized Go applications to ensure consistency across different environments and simplify deployment, resulting in improved portability and resource utilization.",
      //   "Managed Linux servers for deployment purposes, ensuring stability, security, and optimal performance.",
      //   "Integrated WhatsApp API with our Angular applications, providing a comprehensive messaging solution for over 1,000 users."

      // ]
    },
    // {
    //   role: "Front-End Developer",
    //   company: "Quora",
    //   companylogo: require("./assets/images/quoraLogo.png"),
    //   date: "May 2017 – May 2018",
    //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // },
    // {
    //   role: "Software Engineer Intern",
    //   company: "Airbnb",
    //   companylogo: require("./assets/images/airbnbLogo.png"),
    //   date: "Jan 2015 – Sep 2015",
    //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "My own personal side projects that I have managed to finish.",
  projects: [
    {
      image: require("./assets/images/notes.png"),
      projectName: "Gndecnotes",
      projectDesc:
        "Website for engineering students to get notes and study material for exams.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://gndecnotes.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/shmooze.png"),
      projectName: "Shmooze",
      projectDesc:
        "Realtime chat application made with MERN Stack and Websockets.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://shmooze.tanvirsingh.io/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/dataMax.png"),
      projectName: "DataMax Drive Share",
      projectDesc:
        "File storing/sharing platform for organizations.",
      footerLink: [
        {
          name: "Github Repository",
          url: "https://github.com/TanvirSingh007/DataMax-DriveShare"
        }
        //  you can add extra buttons here.
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "AWS Academy Introduction to Cloud Semester 2",
      // subtitle: "Selected as a Finalist by OSGeo",
      image: require("./assets/images/aws-academy-graduate-aws-academy-introduction-to-cloud-semester-2.png"),
      footerLink: [
        {
          name: "Certificate",
          url: "https://www.credly.com/badges/b408c381-10ce-41be-8c22-e0633c33a0ba/public_url"
        },
      ]
    },
    {
      title: "AWS Academy Introduction to Cloud Semester 1",
      // subtitle: "Selected as a Finalist by OSGeo",
      image: require("./assets/images/aws-academy-graduate-aws-academy-introduction-to-cloud-semester-1.png"),
      footerLink: [
        {
          name: "Certificate",
          url: "https://www.credly.com/badges/47a68ad1-9e88-49bf-bc29-04aacd73ee31/public_url"
        },
      ]
    },
    {
      title: "AWS Academy Cloud Foundations",
      // subtitle: "Selected as a Finalist by OSGeo",
      image: require("./assets/images/aws-academy-graduate-aws-academy-cloud-foundations.png"),
      footerLink: [
        {
          name: "Certificate",
          url: "https://www.credly.com/badges/e51e16db-cd2d-4f4f-835d-5e42a5f34e98/public_url"
        },
      ]
    },
    {
      title: "Google Code-In Finalist 2019",
      subtitle: "Selected as a Finalist by OSGeo",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/1D5UnlNk-lbOJDXw43VYcAqjA4_CafOLy/view"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/1mA2mUCO1pVPCMlCOsNh3FIu6nu8ULJn4/view"
        }
      ]
    },
    {
      title: "Google Code-In Finalist 2018",
      subtitle: "Selected as a Finalist by PostgreSQL",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/107dOGQuYISCArYM9sEqu7vrLtDUHnYqP/view"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/11_-8WT0TtmkTXPWVzsUjQs3Yk0B0fAl6/view"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "singhtanvir032@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
